module.exports = __webpack_public_path__ + "img/IMG_8157_L_Foamcore.8f1c7589.jpg";